import {updatePartnerBankInfo} from "../Util/queries";
import {CARD_UPDATE_STATES, PARTNER_CREDIT_UPDATE_CARD_STATE} from "../Components/Payments/creditCardInfoSection";
import {PARTNER_BANK_INFO} from "../Components/Payouts/bankInfoHolder";
import {constructPartnerBankInfo} from "../Factory/factory";
import {API_RESPONSE_MESSAGE} from "../Reducers/apiResponseMessagesReducer";
import axios from "axios";

export const UpdatePartnerBankInfo = (routingNumber, accountHolderName, accountNumber, firstName, lastName, email, clientIP) => async (dispatch) => {
    try {
        let data = {
            "individualInfo": {
                "firstName": firstName,
                "lastName": lastName,
                "email": email,
            },
            "bankAccountInfo": {
                "routingNumber": routingNumber,
                "accountHolderName": accountHolderName,
                "accountNumber": accountNumber,
            },
            "clientIpAddress": clientIP
        }
        let request = await updatePartnerBankInfo(data);
        if (request.status === 200 || request.status === 201 || request.status === 202) {
            dispatch({
                type: PARTNER_CREDIT_UPDATE_CARD_STATE,
                payload: CARD_UPDATE_STATES.success
            })
            dispatch({
                type: PARTNER_BANK_INFO,
                payload: constructPartnerBankInfo(accountHolderName, routingNumber, accountNumber, firstName, lastName, email)
            })
        } else {
            throw new Error(`Client-side error: ${request.statusText}`);
        }
    } catch (e) {
        if(axios.isAxiosError(e) && e.response) {
            dispatch({
                type: API_RESPONSE_MESSAGE,
                payload: e.response.data.errorMessage
            })
        }
        console.error(e);
        dispatch({
            type: PARTNER_CREDIT_UPDATE_CARD_STATE,
            payload: CARD_UPDATE_STATES.failed
        });

    }
}
